// extracted by mini-css-extract-plugin
module.exports = {"tooltip-portal":"_1TJ8BN"};